module.exports = __webpack_public_path__ + "img/myanmar-ltd.9e800d24.jpg";